import { render, staticRenderFns } from "./BtnDownloadLocalXls.vue?vue&type=template&id=bdc3a40e&scoped=true"
import script from "./BtnDownloadLocalXls.vue?vue&type=script&lang=js"
export * from "./BtnDownloadLocalXls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc3a40e",
  null
  
)

export default component.exports